exports.syllabusCourseCode = /\s*course\s*code\s*:*/i;
exports.syllabusCourseName = /\s*course\s*name\s*:*/i;
exports.syllabus = /course\s*contents\s*and\s*lecture\s*schedule/i;
exports.whitespace = /\s/;
exports.module1 = /^\s*1\s*$/i;
exports.module1Topics = /1.\d+/i;
exports.module2 = /^\s*2\s*$/i;
exports.module2Topics = /2.\d+/i;
exports.module3 = /^\s*3\s*$/i;
exports.module3Topics = /3.\d+/i;
exports.module4 = /^\s*4\s*$/i;
exports.module4Topics = /4.\d+/i;
exports.module5 = /^\s*5\s*$/i;
exports.module5Topics = /5.\d+/i;
exports.module6 = /^\s*6\s*$/i;
exports.module6Topics = /6.\d+/i;
exports.zeroCharacter = /^\s*$/;
exports.hours = /\s*\d+\s*hour(s)?\s*/ig;
exports.textbooks = /\s*text\s*books\s*/i;
exports.references = /\s*reference\s*/i;
exports.newItem = /^\s*\d\.\s*|\s*\s*\d\.\s*/;
exports.max = /\s*max\s*/i;
exports.it = /\s*information technology\s*/i;